import React, { useState } from 'react'
import { Link, Navigate } from 'react-router-dom'
import { api } from '../api.js'
import { useConfig } from '../config.jsx'
import { Alert } from '../lib.jsx'

export default function Register() {
  const cfg = useConfig()
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)
  const [done, setDone] = useState(null)

  if (!cfg.loading && !cfg.features.public_signup) return <Navigate to="/login" replace />

  const submit = async (e) => {
    e.preventDefault()
    if (password !== confirm) { setErr('Hasła nie są identyczne'); return }
    setErr(''); setBusy(true)
    try {
      const res = await api.register({ username, email, password })
      setDone(res.message || 'Konto utworzone. Sprawdź swoją skrzynkę e-mail, aby aktywować konto.')
    } catch (e) { setErr(e.message || 'Błąd rejestracji') } finally { setBusy(false) }
  }

  if (done) {
    return (
      <div className="login-wrap">
        <div className="card login-card">
          <div className="brand"><div className="logo">G</div><b>generator<span>PDF</span></b></div>
          <Alert kind="ok">{done}</Alert>
          <div className="tag">Sprawdź swoją skrzynkę e-mail, aby aktywować konto.</div>
          <Link to="/login" className="btn btn-primary" style={{ width: '100%', marginTop: 16, display: 'flex' }}>Przejdź do logowania</Link>
        </div>
      </div>
    )
  }

  return (
    <div className="login-wrap">
      <div className="card login-card">
        <div className="brand"><div className="logo">G</div><b>generator<span>PDF</span></b></div>
        <div className="tag">Utwórz konto</div>
        <form onSubmit={submit}>
          <Alert kind="err">{err}</Alert>
          <div className="field"><label>Nazwa użytkownika</label>
            <input value={username} onChange={e => setUsername(e.target.value)} autoFocus autoComplete="username" required minLength={3} /></div>
          <div className="field"><label>E-mail</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" required /></div>
          <div className="field"><label>Hasło</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="new-password" required minLength={8} /></div>
          <div className="field"><label>Potwierdź hasło</label>
            <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="new-password" required minLength={8} /></div>
          <button className="btn btn-primary" style={{ width: '100%' }} disabled={busy || !username || !email || !password}>
            {busy ? 'Tworzenie konta…' : 'Zarejestruj się'}
          </button>
        </form>
        <div className="tag" style={{ marginTop: 16 }}>Masz już konto? <Link to="/login">Zaloguj się</Link></div>
      </div>
    </div>
  )
}
